module.exports = __webpack_public_path__ + "c66d09028e28d4a3b0aa34a7681dccbb.pdf";